import UserProfile from './UserProfile.component';

export default UserProfile;
